import React from "react";
import NavigationDropdown from "../../../../../../../general-ui/dropdown/navigation-dropdown";
import Icon, { COLORS, ICONS } from "../../../../../../../general-ui/icon";
import TextInput from "../../../../../../../general-ui/text-input/text";
import { filterOptions, QFilters } from "../../hooks/question-prompts.hooks";

type QuestionSearchFilterProps = {
	userSearchTerm: string;
	selectedFilter: QFilters;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onSearch: () => void;
	onFilterChange: (filter: QFilters) => void;
};

const QuestionSearchFilter = ({
	userSearchTerm,
	selectedFilter,
	onChange,
	onSearch,
	onFilterChange,
}: QuestionSearchFilterProps) => {
	return (
		<div className="session-panel-header-options with-filter">
			<TextInput
				defaultValue={userSearchTerm}
				onChange={onChange}
				onBlur={onSearch}
				onEnterKey={onSearch}
				placeholder="Search..."
				className="small"
				isAdmin
			/>
			<NavigationDropdown
				title={<Icon name={ICONS.FILTER} size={12} color={COLORS.WHITE} />}
				className="session-panel-dropdown"
				isArrow={false}
				buttonClassName="round"
				edge="right"
			>
				{filterOptions.map(option => (
					<button
						onClick={() => onFilterChange(option.value)}
						key={option.value}
					>
						{option.label}
						{option.value === selectedFilter && (
							<Icon name={ICONS.CHECKMARK} size={12} color={COLORS.WHITE} />
						)}
					</button>
				))}
			</NavigationDropdown>
		</div>
	);
};

export default QuestionSearchFilter;
